import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: {
          // Aquí irán tus traducciones en español
        }
      },
      en: {
        translation: {
          // Aquí irán tus traducciones en inglés
        }
      }
    },
    lng: 'es', // Idioma por defecto
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;